export default __webpack_public_path__ + "static/media/cannes-2x.b5c917b2.webp";